export const NAMESPACE = "MergeTagTableModal";

export const PAGES = {
  CHOOSE_OPTIONS: "chooseOptions",
  COPY_TEXT: "copyText"
};
